<!-- Retry Button Template -->
<ng-template #retryButton let-prompt="prompt">
    <button
        *ngIf="prompt"
        class="retry-button"
        color="primary"
        type="button"
        fxFlex="0 1 auto"
        mat-icon-button
        matTooltip="Retry SCORM processing"
        i18n-matTooltip
        (click)="onRetry(prompt)"
    >
        <mat-icon class="md-24">refresh</mat-icon>
    </button>
</ng-template>

<div fxLayout="column" class="main-wrapper-core" [ngClass]="{ borderless: resourceForm?.value?.scorm_uri }">
    <div class="w-100">
        <div fxFlex="0 0 100%" fxLayout="column wrap" fxLayoutAlign="start center" class="user-manage-tests">
            <ng-container *ngIf="scormParserPromptStateSub | async; let scormParserPromptState; else: empty">
                <ng-container *ngTemplateOutlet="scormImageViewWrapper"></ng-container>
                <div
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    *ngIf="Utils.isOnProgressPromptStatus(scormParserPromptState.status)"
                >
                    <span>Parsing SCORM package</span>
                    <app-kd-logo-loading size="small"></app-kd-logo-loading>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" *ngIf="scormParserPromptState.status == 'ERROR'">
                    <span class="error-message">{{ scormParserPromptState.error }}</span>
                    <ng-container
                        [ngTemplateOutlet]="retryButton"
                        [ngTemplateOutletContext]="{ prompt: scormParserPromptState.prompt }"
                    ></ng-container>
                </div>
                <ng-container
                    *ngIf="scormParserPromptState.status == 'COMPLETED'"
                    [ngTemplateOutlet]="scormPlayWrapper"
                ></ng-container>
            </ng-container>
            <ng-template #empty>
                <ng-container *ngIf="resource?.scorm; else uploadTemplate">
                    <ng-container *ngTemplateOutlet="scormImageViewWrapper"></ng-container>
                    <ng-container *ngTemplateOutlet="scormPlayWrapper"></ng-container>
                </ng-container>
                <ng-template #uploadTemplate>
                    <app-scorm-upload
                        (onScormUploaded)="scormMedia = $event; onScormUploaded($event)"
                    ></app-scorm-upload>
                </ng-template>
            </ng-template>
        </div>
    </div>
</div>

<!-- SCORM image Wrapper Template -->
<ng-template #scormImageViewWrapper>
    <div class="scorm-block-wrap mt-1">
        <ng-container *ngIf="resourceForm.value.media_id">
            <app-image-view
                class="mt-1 mb-1"
                [ignoreThumbnail]="true"
                [media_id]="resourceForm.value.media_id"
                [showImgModalOnClick]="true"
                [proportional]="false"
            >
                <button
                    fxHide
                    class="remove-image"
                    mat-icon-button
                    color="warn"
                    type="button"
                    matTooltip="Remove SCORM"
                    i18n-matTooltip
                    (click)="onRemove()"
                >
                    <mat-icon class="md-18">delete_outline</mat-icon>
                </button>
            </app-image-view>
        </ng-container>
        <img *ngIf="!resourceForm.value.media_id" src="assets/images/Default_scorm_img.png" alt="SCORM" />
    </div>
</ng-template>

<!-- SCORM Play Wrapper Template -->
<ng-template #scormPlayWrapper>
    <div fxLayout="row" fxLayoutAlign="start center">
        <span>{{ scormMedia?.filename ?? resource?.scorm?.origin_file ?? 'SCORM package' }}</span>
        <button
            color="primary"
            type="button"
            fxFlex="0 1 auto"
            mat-icon-button
            matTooltip="Play SCORM"
            i18n-matTooltip
            (click)="onPlay()"
        >
            <mat-icon>play_circle</mat-icon>
        </button>
    </div>
</ng-template>

<div fxLayout="column" fxLayoutGap="10px" *ngIf="resourceItems$ | async as resourceItems">
    <ng-container *ngIf="resourceItems.length > 0">
        <div class="res-bull-label" i18n>SCORM Content</div>
        <div class="res-bull" *ngFor="let item of resourceItems; let index = index">
            <span class="index">{{ index + 1 }}</span>
            <span class="res-item-name ecourse" [class.parent]="!item.sco_parent_id">{{ item.title }}</span>
        </div>
    </ng-container>
</div>

<ng-template #extraTabTemplateToBeInParent>
    <!-- <mat-tab #extraTab label="Extra" i18n-label style="max-height: 100%">

    </mat-tab> -->
</ng-template>
<ng-template #contentTemplateToBeInParent>
    <mat-expansion-panel #trailerExpansionPanel [expanded]="true" class="user-manage-course-expantion res-creat-manag">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>video_library</mat-icon>
                <div i18n>Trailer</div>
                <mat-icon
                    class="icon-explain"
                    matTooltip="Video presentation of this course presenting it with a trailer"
                    i18n-matTooltip
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <mat-icon
                    *ngIf="trailerExpansionPanel.expanded && videoLinkControl?.videoMedia"
                    class="md-24 remove-trailer"
                    (click)="$event.stopPropagation(); videoLinkControl.clearMedia()"
                    >delete_outline</mat-icon
                >
                <span
                    matTooltip="Indicator of field change"
                    i18n-matTooltip
                    class="cell-indicator"
                    [ngClass]="{ green: resourceForm.get('medias.trailer')?.dirty }"
                ></span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <app-video-link-control
                class="trailer-uploader-wrapper"
                [formControl]="resourceForm.get('medias.trailer') | cast"
                [uploaderBtnLabel]="'Upload trailer'"
                i18n-uploaderBtnLabel="@@uploadTrailer"
                [resourceId]="resource?.id"
                [canRemoveMedia]="false"
            ></app-video-link-control>
        </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel [expanded]="true" class="user-manage-course-expantion res-creat-manag">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>display_settings</mat-icon>
                <div i18n>Default name</div>
                <mat-icon class="icon-explain" matTooltip="Default name of the scorm to be displayed in the player"
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <span matTooltip="Indicator of field change" i18n-matTooltip class="cell-indicator"></span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <div fxLayoutGap="4px" fxLayout="row" class="w-50">
                <app-title-translation
                    type="title"
                    placeholder="Set default name"
                    i18n-placeholder
                    class="material-title-translation"
                    formControlName="labelTranslation"
                ></app-title-translation>
            </div>
        </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel [expanded]="true" class="user-manage-course-expantion res-creat-manag">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>fingerprint</mat-icon>
                <div i18n="@@SKU-ArticleNumber">SKU/ Article number</div>
                <mat-icon
                    class="icon-explain"
                    i18n-matTooltip
                    matTooltip="SCORM code is a unique field, autogenerated when empty."
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <span matTooltip="Indicator of field change" i18n-matTooltip class="cell-indicator"></span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <app-resource-article-code-form
                fxFlex="0 1 100%"
                formControlName="article_code"
                [resourceId]="resource?.id"
            ></app-resource-article-code-form>
        </ng-template>
    </mat-expansion-panel>
    <ng-container *ngIf="customFields$ | async as customFields">
        <ng-container *ngIf="customFields && customFields.length > 0">
            <app-resources-custom-fields
                [resource]="resource"
                [customFields]="customFields"
            ></app-resources-custom-fields>
        </ng-container>
    </ng-container>
    <mat-expansion-panel
        fxHide
        [expanded]="false"
        class="user-manage-course-expantion scorm-files-expansion res-creat-manag"
    >
        <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon>display_settings</mat-icon>
                <div i18n>SCORM Files</div>
                <mat-icon class="icon-explain" matTooltip="Default name of the scorm to be displayed in the player"
                    >help_outline</mat-icon
                >
            </mat-panel-title>
            <mat-panel-description fxLayoutAlign="end center">
                <span matTooltip="Indicator of field change" i18n-matTooltip class="cell-indicator"></span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <div fxHide fxLayout="column" class="mt-1">
                <div class="res-bull-label mb-0" i18n>SCORM Files</div>
                <app-scorm-manager-files [resource]="resource"></app-scorm-manager-files>
            </div>
        </ng-template>
    </mat-expansion-panel>
</ng-template>
<ng-template #smallLoading>
    <div fxLayout="row" fxLayoutAlign="start center" class="spinner-container mt-2">
        <app-kd-logo-loading size="small"></app-kd-logo-loading>
    </div>
</ng-template>
